import { ColumnDef } from "@tanstack/react-table";
import type { IcmLineItem } from "@/icm/types";
import { formatTraceValue, humanizeKey } from "@/icm/utils";

const TraceCol = (key: string): ColumnDef<IcmLineItem> => ({
  id: key,
  header: humanizeKey(key),
  meta: { size: "130px" },
  cell: ({ row }) => formatTraceValue(key, row.original.calculation_trace[key]),
});

export default TraceCol;
